var common = require("../../utiles/common");

module.exports = function (req, next) {
  console.log(req);
  setTimeout(function () {
    common.fetch("/auth/setParam", {
      method: "POST",
      data: JSON.stringify({str: req.href})
    });
    common.fetch("/auth/isLogin", {
      success: function (data) {
        // 初始化Profile
        if (data.data) {
          var service = sessionStorage.getItem("service");
          if(service){
            var isLoginUrl = "/auth/isAgentLogin?service=" + service;
            common.fetch(isLoginUrl, {
              success: function (data) {
                if (data.redirectUrl) {
                  common.redirectTo(data.redirectUrl);
                }
              },
            })
          } else {
            common.redirectTo("/#/appList");
          }
        }
      },
    });
  }, 300);
  if (window.location.href.split("?")[1]) {
    var searchs = common.urlSearch(window.location.href);
    if (searchs.service) {
      delete searchs.service;
    }
    if (searchs.callBack) {
      delete searchs.callBack;
    }
    if (searchs.context) {
      delete searchs.context;
    }
    var searchUrl = common.objToSearchUrl(searchs);
    sessionStorage.setItem("searchUrl", searchUrl);
  }
  if (req.query && req.query.context) {
    sessionStorage.setItem("context", req.query.context);
  }
  if (req.query && req.query.state) {
    sessionStorage.setItem("state", req.query.state);
  }
  if (req.query && req.query.service) {
    sessionStorage.setItem("service", req.query.service);
  }
  if (req.query && req.query.callBack) {
    sessionStorage.setItem("callBack", req.query.callBack);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/routes/callback/login.js
// module id = 187
// module chunks = 0